import { render } from "./MultiPublisherYieldDataCard.vue?vue&type=template&id=264963fb"
import script from "./MultiPublisherYieldDataCard.vue?vue&type=script&lang=js"
export * from "./MultiPublisherYieldDataCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__